export const MAX_REQUEST_NUMBER = 1000000
export const EMPTY_NUMBER_ID = -1
export const EMPTY_NUMBER_INDEX = -1
export const LATEST_DEVICE_VERSION = '7'
export * from './route'
export * from './ui'
